import { OnboardingFlowConfig } from '../interfaces/onboarding.interface';

export const ONBOARDING_FLOW_CONFIGS: OnboardingFlowConfig[] = [
  {
    id: 'general',
    icon: 'fa-solid fa-house',
    moduleRouteSegment: null,
    segments: [
      { id: 'general' },
      { id: 'general-selfserve', optional: true },
      { id: 'general-selfserve-banner', optional: true },
      { id: 'project-dashboard' },
    ],
  },
  {
    id: 'simulator',
    icon: 'fa-solid fa-flask',
    moduleRouteSegment: 'simulations',
    segments: [
      { id: 'simulator' },
      { id: 'simulator-results', optional: true },
    ],
  },
  {
    id: 'monitoring',
    icon: 'fa-solid fa-tower-broadcast',
    moduleRouteSegment: 'monitoring',
    segments: [
      { id: 'monitoring-dashboard' },
      { id: 'monitoring-stage' },
      { id: 'monitoring-maturitymeasurement', optional: true },
      { id: 'monitoring-temperaturemeasurement', optional: true },
    ],
  },
  {
    id: 'analytics',
    icon: 'fa-solid fa-chart-line',
    moduleRouteSegment: 'analytics',
    segments: [
      { id: 'analytics-intro' },
      { id: 'analytics-dashboard-empty', optional: true },
      { id: 'analytics-dashboard-data', optional: true },
      { id: 'analytics-upload' },
      { id: 'quality-control-intro' },
      { id: 'quality-control-setup', optional: true },
      { id: 'quality-control-dashboard', optional: true },
    ],
  },
];

/**
 * Maps URL patterns to segment IDs for the route-triggered flow engine.
 * ORDER MATTERS — most specific pattern must come first.
 */
export const ONBOARDING_SEGMENT_ROUTE_MAP: Array<{ pattern: RegExp; segmentId: string }> = [
  // QC index only — not sub-routes like /lots or /pours
  { pattern: /\/projects\/[^/]+\/analytics\/quality-control$/, segmentId: 'quality-control-intro' },
  // Upload page lives at /analytics/documents (empty child path)
  { pattern: /\/projects\/[^/]+\/analytics\/documents$/, segmentId: 'analytics-upload' },
  // Analytics index only — not QC, documents, data-explorer sub-routes
  { pattern: /\/projects\/[^/]+\/analytics$/, segmentId: 'analytics-intro' },
  // Stage detail: an ObjectId segment after /monitoring/ (excludes devices, data-explorer)
  { pattern: /\/projects\/[^/]+\/monitoring\/(?!devices$|data-explorer$)[^/]+$/, segmentId: 'monitoring-stage' },
  // Monitoring index only — not devices, data-explorer, or stage sub-routes
  { pattern: /\/projects\/[^/]+\/monitoring$/, segmentId: 'monitoring-dashboard' },
  // Simulations index only
  { pattern: /\/projects\/[^/]+\/simulations$/, segmentId: 'simulator' },
  { pattern: /\/projects\/[^/]+$/, segmentId: 'project-dashboard' },
  { pattern: /^\/$/, segmentId: 'general' },
];
